<template>
  <div>
    <div class="toolbar">
      <ListSearchForm @change="fetchData" ref="search" style="display:inline-block;"></ListSearchForm>
      <el-button type="primary" @click="handleBatch">添加题目</el-button>
    </div>
    <el-table
      ref="multipleTable"
      :data="tableData"
      border
      style="width: 100%"
      @selection-change="handleSelectionChange"
      @sort-change="handleSort"
    >
      <el-table-column prop="id" label="ID" width="80" sortable="custom"></el-table-column>
      <el-table-column prop="level" label="等级" sortable="custom" width="80"></el-table-column>
      <el-table-column prop="num" label="课程" width="80"></el-table-column>
      <el-table-column label="位置" width="150">
        <template v-slot="column">
          <el-link v-for="(item, key) in (column.row.locations || [])" :key="key" :href="'#/collection/' + item.coll_id" target="_blank">
            {{item.coll_id}}: {{item.memo}}
          </el-link>
        </template>
      </el-table-column>
      <el-table-column label="内容">
        <template v-slot="column">
          <ExercisePreview :entity="column.row"></ExercisePreview>
        </template>
      </el-table-column>
      <el-table-column class-name="operations" fixed="right" label="操作" width="120">
        <template slot-scope="scope">
          <el-button @click="showQa(scope.row)" type="text" size="small">解析</el-button>
          <el-button @click="showTrans(scope.row)" type="text" size="small">翻译</el-button>
          <el-button @click="showWords(scope.row)" type="text" size="small">分词</el-button>
          <el-button @click="updateModel(scope.row)" type="text" size="small">编辑</el-button>
          <el-button @click="handleDelete(scope.row)" type="text" size="small">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 50, 100, 200]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      v-if="total>pageSize"
    >
    </el-pagination>
    <el-dialog title="分词管理" :visible.sync="showWordDialog" width="80%">
      <ExerciseWord ref="word" :model="showWordModel"></ExerciseWord>
    </el-dialog>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="60%">
      <ExerciseForm ref="exrform"></ExerciseForm>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitModel">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="题目解析" :visible.sync="qaDialog" width="60%">
      <ExerciseQaHistory v-if="qaModel" :exr_id="qaModel.id" show-build></ExerciseQaHistory>
    </el-dialog>
    <ModelTranslation ref="trans" type="exercise"></ModelTranslation>
    <Sidebar :visible.sync="batchVisible" header="添加题目">
      <ExerciseForm ref="batchform"></ExerciseForm>
      <div class="text-right">
        <el-button @click="batchVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitBatch">确 定</el-button>
      </div>
    </Sidebar>
  </div>
</template>

<script>
import ExerciseForm from './ExerciseForm'
import ExerciseWord from './ExerciseWord'
import ExercisePreview from './ExercisePreview'
import Sidebar from './../Sidebar'
import table from './../mixins/table.js'
import ListSearchForm from './ListSearchForm'
import ExerciseQaHistory from "./ExerciseQaHistory";
import ModelTranslation from "@/views/locale/ModelTranslations.vue";

export default {
  name: 'ExerciseList',
  props: {
    knowtype: String
  },
  mixins: [table],
  data () {
    return {
      multipleSelection: [],
      dialogTitle: '添加题目',
      dialogVisible: false,
      batchVisible: false,
      fetchUrl: 'exercise_list',
      showWordDialog: false,
      showWordModel: null,

      qaDialog: false,
      qaModel: null
    }
  },
  components: {ModelTranslation, ExerciseForm, ExercisePreview, Sidebar, ListSearchForm, ExerciseWord, ExerciseQaHistory },
  watch: {
    knowtype () {
      this.fetchData()
    }
  },
  methods: {
    toggleSelection (rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row)
        })
      } else {
        this.$refs.multipleTable.clearSelection()
      }
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    handleFetchConfig (config) {
      if (this.$refs.search) {
        Object.assign(config.params, {
          status: 1,
          knowType: this.knowtype,
          course_id: this.$store.state.currentCourseId,
          level: this.$refs.search.level || null,
          id: this.$refs.search.eid || null,
          num: this.$refs.search.num || null,
          tid: this.$refs.search.tid || null,
          no_wrongs: this.$refs.search.kewen_under || null,
          data_json: this.$refs.search.search || null
        })
      } else {
        Object.assign(config.params, {
          status: 1,
          course_id: this.$store.state.currentCourseId,
          knowType: this.knowtype
        })
      }
    },
    createModel () {
      this.dialogVisible = true
      this.dialogTitle = '添加题目'
      window.setTimeout(() => {
        if (this.$refs.exrform.model.id) {
          this.$refs.exrform.reset()
        }
      }, 10)
    },
    submitModel () {
      this.$refs.exrform.submit().then(res => {
        this.dialogVisible = false
        this.fetchData()
        this.$refs.exrform.reset()
      })
    },
    updateModel (item) {
      this.dialogVisible = true
      this.dialogTitle = '编辑题目: ' + item.id
      setTimeout(() => {
        this.$refs.exrform.reset(item)
      }, 10)
    },
    handleBatch () {
      this.batchVisible = true;
    },
    submitBatch () {
      this.$refs.batchform.submit().then(() => {
        this.fetchData()
        this.$refs.batchform.reset({
          tid: this.$refs.batchform.model.tid,
          level: this.$refs.batchform.model.level,
          lid: this.$refs.batchform.model.lid
        })
      })
    },
    handleDelete (item) {
      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(res => {
        this.$http.put(this.$urls.exercise_update, { status: 0 }, {
          params: {id: item.id}
        }).then(() => {
          this.fetchData()
        })
      })
    },
    showWords (item) {
      this.showWordModel = item
      this.showWordDialog = true
    },
    showQa (item) {
      this.qaModel = item
      this.qaDialog = true
    },
    showTrans(item) {
      this.$refs.trans.show(item.id, {title: `翻译: ${item.id}`});
    }
  }
}
</script>